import { Coverage } from '@amfam/policy/models';

export class CoveragesModel {
  isImpliedCoverage: boolean;
  isLiabilityCoverage: boolean;
  isStandardCoverage: boolean;
  isVisible: boolean;
  subHeading: string;
  coverage: Coverage;

  constructor(
    public coverageData: Coverage,
    public coverageSubHeadingString: string
  ) {
    this.isImpliedCoverage = coverageData.coverageType === 'Implied';
    this.isLiabilityCoverage = coverageData.coverageType === 'Liability Group';
    this.isStandardCoverage = !this.isImpliedCoverage && !this.isLiabilityCoverage;
    this.isVisible = this.isStandardCoverage || coverageData.limitTerms.length > 0;
    this.subHeading = coverageSubHeadingString;
    this.coverage = coverageData;
  }
}

export interface PolicyCoverages {
  coverages: CoveragesModel[];
  additionalCoverages: string[];
}
